import PropTypes from 'prop-types';
import { isEmpty, length } from 'ramda';
import classNames from 'classnames';

import MapNoteHeader from '../map-note-sheet-editable/MapNoteHeader.jsx';
import MapNoteChangesButtons from '../map-note-sheet-editable/MapNoteChangesButtons.jsx';
import MapNoteSubject from '../map-note-sheet-editable/MapNoteSubject.jsx';
import MapNoteTypeDropdown from '../map-note-sheet-editable/MapNoteTypeDropdown.jsx';
import s from '../map-note-sheet-editable/MapNoteSheetEditable.module.scss';
import MapNoteDescription from '../map-note-sheet-editable/MapNoteDescription.jsx';
import MapNoteAddImages from '../map-note-sheet-editable/MapNoteAddImages.jsx';
import Spinner from '../spinner/Spinner.jsx';

const MapNoteSheetNew = props => (
    <div className={s.mapNoteSheetContainer}>
        <div className={s.mapNoteSheet}>
            <MapNoteHeader onClose={props.onClose} />
            <MapNoteChangesButtons isEnabled={!isEmpty(props.updatedFields) && length(props.updatedFields.subject) > 0} onSave={props.onSave} onCancel={props.onClose} />
            <MapNoteSubject onTextChange={props.onSubjectChange} text={props.updatedFields.subject} placeholder="New Note" />
            <MapNoteTypeDropdown selected={props.updatedFields.noteType} onOptionClick={props.onTypeChange} />
            <MapNoteDescription onTextChange={props.onDescriptionChange} text={props.updatedFields.description} placeholder="Add a comment..." />
            <MapNoteAddImages onImageUpload={props.onImageUpload} uploadedImages={props.updatedFields.uploadedImages} onImageDelete={props.onImageDelete} />
        </div>
        <div className={classNames({ [s.loading]: props.loading })}>
            <Spinner loading={props.loading} />
        </div>
    </div>
);

MapNoteSheetNew.propTypes = {
    loading: PropTypes.bool.isRequired,
    updatedFields: PropTypes.object.isRequired,
    onSubjectChange: PropTypes.func.isRequired,
    onDescriptionChange: PropTypes.func.isRequired,
    onTypeChange: PropTypes.func.isRequired,
    onImageUpload: PropTypes.func.isRequired,
    onImageDelete: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
};

export default MapNoteSheetNew;
